<rb-dialog (buttonClick)="onDialogButtonClick($event)"
           (closeClick)="onClose()"
           (maximizedChange)="onMaximizedChange($event)"
           [(maximized)]="dialogMaximized"
           [config]="dialogConfig">
  <div class="flex gap-x-[4rem]">
    <rb-view-section *ngIf="request.documentId" class="w-[calc(100%-47.9rem)]">
      <ng-container *ngrxLet="paymentDocumentType$ | async as paymentDocumentType">
        <div *ngrxLet="paymentDocumentUrl$ | async as paymentDocumentUrl"
             [style.max-height]="docViewerMaxHeight"
             class="overflow-hidden rounded-[0.5rem] h-[100vh] w-full">
          <rb-image-viewer *ngIf="paymentDocumentType === 'image'"
                           alt="document"
                           class="block h-full w-full"
                           src="{{ paymentDocumentUrl }}"></rb-image-viewer>
          <rb-pdf-viewer *ngIf="paymentDocumentType === 'pdf'"
                         class="block h-full w-full"
                         src="{{ paymentDocumentUrl }}"></rb-pdf-viewer>
        </div>
      </ng-container>
    </rb-view-section>
    <form [formGroup]="form"
          [style.height]="request.documentId ? docViewerMaxHeight : 'auto'"
          class="{{ request.documentId ? 'w-[43.9rem]' : 'w-full' }} flex flex-col gap-y-[2rem]">
      <rb-document-name-bar (renamingChange)="onDocumentNameRenamingChange($event)"
                            *ngIf="request.documentId"
                            [clientId]="request.clientId"
                            [documentId]="request.documentId"
                            [extension]="request.documentExtension!"
                            [name]="request.documentName!"></rb-document-name-bar>
      <rb-edit-payment (fetchClientBeneficiaries)="fetchClientBeneficiaries($event)"
                       (paymentFieldsToRetainChange)="onPaymentFieldsToRetainChange($event)"
                       (saveBeneficiary)="saveBeneficiary($event)"
                       [addPaymentEnabled]="!request.id && !request.documentId"
                       [addPaymentLoading]="addPaymentLoading$ | async"
                       [beneficiariesLoading]="beneficiariesLoading$ | async"
                       [beneficiaries]="beneficiaries$ | async"
                       [beneficiaryEditing]="beneficiaryEditing$ | async"
                       [clientInputDisabled]="!!request.clientId && !!request.documentId"
                       [errorKey$]="errorKey$"
                       [paymentAccounts]="paymentAccounts$ | async"
                       [paymentClients]="paymentClients$ | async"
                       [paymentFieldsToRetain]="paymentFieldsToRetain"
                       [predictedClient]="request.predictedClient || null"
                       [singleColumn]="!!request.documentId"
                       class="overflow-y-auto"
                       formControlName="payment">
      </rb-edit-payment>
    </form>
  </div>
</rb-dialog>
